// AnimatedImage.jsx
import { useEffect, useRef, useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";

export default function AnimatedImage({
                                          src,
                                          alt = "",
                                          loopMs = 1800,
                                          aberration = true,
                                          className = "",
                                      }) {
    const [tick, setTick] = useState(0);
    const nodeRef = useRef(null);

    useEffect(() => {
        const id = setInterval(() => setTick((t) => t + 1), loopMs);
        return () => clearInterval(id);
    }, [loopMs]);

    return (
        <div className={`relative inline-block ${className}`}>
            <SwitchTransition mode="out-in">
                <CSSTransition
                    key={tick}               // retriggers every loop
                    nodeRef={nodeRef}
                    classNames="float"
                    timeout={loopMs}         // keep CSS + JS in sync
                >
                    <img
                        ref={nodeRef}
                        src={src}
                        alt={alt}
                        className={`select-none will-change-transform ${
                            aberration ? "aberration" : ""
                        }`}
                        draggable="false"
                    />
                </CSSTransition>
            </SwitchTransition>
        </div>
    );
}
